import React, { useEffect, useState, useCallback, useRef } from 'react';
import "./paymentTesting.css"
import axios from 'axios';
import Loader from './Loader';
import Turnstile from './Turnstile';

export default function PaymentTest() {
  const [captchaToken, setCaptchaToken] = useState("");
  const[cargando, setCargando] = useState(false);
  const turnstileRef = useRef();
  const [valid, setValid] = useState(null);
  const [formData, setFormData] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    email: "",
    numeroTarjeta: "",
    mesExpiracion: "",
    anioExpiracion: "",
    nombreTarjeta: "",
    cvv: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    validarFechaExpiracion(formData.mesExpiracion, formData.anioExpiracion);
  }, [formData.mesExpiracion, formData.anioExpiracion]);

  const validarCampo = (name, value) => {
    let error = "";

    switch (name) {
      case "nombre":
      case "apellido":
      case "nombreTarjeta":
        if (!/^[a-zA-ZÁÉÍÓÚÑáéíóúñ\s]*$/.test(value)) {
          error = "Solo se permiten letras";
        }
        break;
      case "telefono":
        if (!/^\d{8}$/.test(value)) {
          error = "Debe tener 8 dígitos";
        }
        break;
      case "email":
        if (!/^\S+@\S+\.\S+$/.test(value)) {
          error = "Correo no válido";
        }
        break;
      case "numeroTarjeta":
        if (!/^\d{12,19}$/.test(value)) {
          error = "Debe tener entre 12 y 19 dígitos ";
        }
        if(value.replace(/\D/g, '').length >= 12){
          setValid(isValidCardNumber(value));
        }
        else{
          setValid(null);
        }
        break;
      case "cvv":
        if (!/^\d{3,4}$/.test(value)) {
          error = "Debe tener 3 o 4 dígitos";
        }
        break;
        default:
          break;
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const validarFechaExpiracion = (mes, anio) => {
    let error = "";
    if (mes && anio) {
      const fechaIngresada = new Date(Number(anio), Number(mes), 0); // último día del mes
      const hoy = new Date();
      if (fechaIngresada < hoy) {
        error = "Tarjeta vencida";
      }
    }
    setErrors((prev) => ({ ...prev, fechaExpiracion: error }));
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "mesExpiracion" || name === "anioExpiracion") {
      validarFechaExpiracion(
        name === "mesExpiracion" ? value : formData.mesExpiracion,
        name === "anioExpiracion" ? value : formData.anioExpiracion
      );
    } else {
      validarCampo(name, value);
    }
  };

  function isValidCardNumber(cardNumber) {
    // Elimina espacios o guiones por si el usuario escribe el número con ellos
    const sanitized = cardNumber.replace(/[\s-]/g, '');
  
    // Verifica que solo contenga dígitos
    if (!/^\d+$/.test(sanitized)) return false;
  
    let sum = 0;
    let shouldDouble = false;
  
    // Recorre el número desde el final hacia el principio
    for (let i = sanitized.length - 1; i >= 0; i--) {
      let digit = parseInt(sanitized[i], 10);
  
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
  
      sum += digit;
      shouldDouble = !shouldDouble;
    }
  
    // El número es válido si la suma es múltiplo de 10
    return sum % 10 === 0;
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    const camposConError = Object.values(errors).filter((e) => e);
    if (camposConError.length > 0 || !captchaToken || !valid) {
      alert("Por favor corrige los errores antes de enviar y verifica el captcha antes de enviar.");
      return;
    }
    
    setCargando(true);
    try {
      console.log("captcha token:",captchaToken);
      const verificacion = await axios.post(`${process.env.REACT_APP_URL_BACKEND}/verificar-captcha`, {
        token: captchaToken,
      });

      if (!verificacion.data.success) {
        setCargando(false);
        alert("Verificación de captcha fallida.");
        turnstileRef.current?.reset();
        setCaptchaToken("");
        return;
      }
      /*const body = {
        method_payment: 'EPAY',
        type_detail: 'product',
        total_amount: 150,
        currency: 'GTQ',
        deviceFinger: '',
        client: {
          first_name: 'Bayron',
          last_name: 'Antonio',
          phone: '5022435422',
          email: 'Bayron1121232123@gmail.com',
          country: 'GT',
          city: 'Guatemala',
          state: 'Guatemala',
          postal_code: '401',
          location: 'zona 10',
        },
        detail: [
          {
            uuid_product: '0',
            name: 'descri venta',
            amount: 150,
            quantity: '1',
            Subtotal: 150,
          },
        ],
        card_payment: {
          name_card: 'Hector Xocop',
          expiration_month: 12,
          expiration_year: 22,
          number_card: '4000000000000416',
          cvv_card: '4567',
          quota_active: false,
          quota: 1,
        },
      };*/


      const payload = {
        method_payment: 'PAGALO',
        type_detail: 'Real payment',
        total_amount: 5.00,
        currency: 'GTQ',
        client: {
          first_name: formData.nombre,
          last_name: formData.apellido,
          phone: formData.telefono,
          email: formData.email,
          country: 'GT',
          /*city: 'Guatemala',
          state: 'Guatemala',
          postal_code: '01007',
          location: '29-92',*/
        },
        detail: [
          {
            uuid_product: '0',  //Obligatorio aunque la documentacion indique que no
            name: 'Alquiler de cancha',
            amount: 5.00,
            quantity: '1',
            Subtotal: 5.00, // usar S mayuscula aunque la documentacion indique minuscula
          }
        ],
        card_payment: {
          name_card: formData.nombreTarjeta,
          expiration_month: formData.mesExpiracion,  // número, no string formData.mesExpiracion
          expiration_year: formData.anioExpiracion.slice(-2),  //formData.anioExpiracion.toString().slice(-2) número, no string - probar 4 digitos pero puede ser que haya que cambiar a 2
          number_card: formData.numeroTarjeta, //valor de prueba: 4000000000000416
          cvv_card: formData.cvv,
          quota_active: false,
          quota: 1,
        }
      };
      // Aquí iría la lógica para enviar los datos al backend

        const response = await axios.post(
          process.env.REACT_APP_URL_PAYMENT,
          payload,
          {
            maxBodyLength: Infinity,
            headers: {
              Authorization: process.env.REACT_APP_PAYMENT_CREDENTIALS,
              'Content-Type': 'application/json',
            },
          }
        );
        console.log("Pago exitoso:", response.data);
        alert("Pago realizado con exito");
      } catch (error) {
        console.error("Error al procesar el pago:", error);
        alert("No se pudo procesar el pago");
        turnstileRef.current?.reset();
        setCaptchaToken("");
      }
      finally{
        setCargando(false);
      }
    };

    const handleVerify = useCallback((token) => {
      setCaptchaToken(token);
    }, []);

  return (
    <div className='contenedor-pagina'>
      {cargando && <Loader/>}
      <div className="form-pago-test">
        <h2>Pago con Tarjeta</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
            {errors.nombre && <small className="error-text">{errors.nombre}</small>}
          </div>

          <div className="form-group">
            <label>Apellido</label>
            <input
              type="text"
              name="apellido"
              value={formData.apellido}
              onChange={handleChange}
              required
            />
            {errors.apellido && <small className="error-text">{errors.apellido}</small>}
          </div>

          <div className="form-group">
            <label>Teléfono</label>
            <input
              type="text"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              required
            />
            {errors.telefono && <small className="error-text">{errors.telefono}</small>}
          </div>

          <div className="form-group">
            <label>Correo Electrónico</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && <small className="error-text">{errors.email}</small>}
          </div>

          <div className="form-group">
            <label>Número de Tarjeta</label>
            <input
              type="text"
              name="numeroTarjeta"
              minLength="12"
              maxLength="19"
              value={formData.numeroTarjeta}
              onChange={handleChange}
              required
            />
            {valid === true && <p style={{ color: 'green' }}>✅ Número válido</p>}
            {valid === false && <p style={{ color: 'red' }}>❌ Número inválido</p>}
            {errors.numeroTarjeta && <small className="error-text">{errors.numeroTarjeta}</small>}
          </div>

          <div className="form-group">
          <label>Fecha de Vencimiento</label>
          <div className="date-container" style={{ display: 'flex', gap: '10px' }}>
            <select
              name="mesExpiracion"
              value={formData.mesExpiracion}
              onChange={handleChange}
              required
            >
              <option value="">Mes</option>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                  {String(i + 1).padStart(2, '0')}
                </option>
              ))}
            </select>
            <select
              name="anioExpiracion"
              value={formData.anioExpiracion}
              onChange={handleChange}
              required
            >
              <option value="">Año</option>
              {[...Array(15)].map((_, i) => {
                const year = new Date().getFullYear() + i;
                return (
                  <option key={year} value={year}>{year}</option>
                );
              })}
            </select>
          </div>
          {errors.fechaExpiracion && <small className="error-text">{errors.fechaExpiracion}</small>}
        </div>

        <div className="form-group">
          <label>CVV</label>
          <input
            type="text"
            name="cvv"
            maxLength="4"
            value={formData.cvv}
            onChange={handleChange}
            required
          />
          {errors.cvv && <small className="error-text">{errors.cvv}</small>}
        </div>

          <div className="form-group">
            <label>Nombre en la Tarjeta</label>
            <input
              type="text"
              name="nombreTarjeta"
              value={formData.nombreTarjeta}
              onChange={handleChange}
              required
            />
            {errors.nombreTarjeta && <small className="error-text">{errors.nombreTarjeta}</small>}
          </div>

          <div className="form-group">
            <label>Total a pagar</label>
            <input
              type="text"
              name="total"
              value="Q.5.00"
              readOnly
              disabled
            />
          </div>
          <Turnstile
            ref={turnstileRef}
            sitekey={process.env.REACT_APP_SITE_KEY}
            onVerify={handleVerify}
          />
          <button type="submit" disabled={!captchaToken}>Pagar</button>
        </form>
      </div>
    </div>
  );
}
